// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs-hotkeys__tabs--3NgOt"};